export const mq = {
  phone: '(max-width: 767px)',
  tablet: '(min-width: 768px)',
  tabletOnly: '(min-width: 768px) and (max-width: 1024px)',
  desktop: '(min-width: 1024px)',
};



// WEBPACK FOOTER //
// ./src/utils.ts